/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetDefaultImagesResponseData,
  GetDefaultImagesResponseDataFromJSON,
  GetDefaultImagesResponseDataFromJSONTyped,
  GetDefaultImagesResponseDataToJSON
} from './GetDefaultImagesResponseData'

/**
 *
 * @export
 * @interface GetDefaultImagesResponse
 */
export interface GetDefaultImagesResponse {
  /**
   *
   * @type {number}
   * @memberof GetDefaultImagesResponse
   */
  status?: number
  /**
   *
   * @type {GetDefaultImagesResponseData}
   * @memberof GetDefaultImagesResponse
   */
  data?: GetDefaultImagesResponseData
}

export function GetDefaultImagesResponseFromJSON(json: any): GetDefaultImagesResponse {
  return GetDefaultImagesResponseFromJSONTyped(json, false)
}

export function GetDefaultImagesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetDefaultImagesResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetDefaultImagesResponseDataFromJSON(json['data'])
  }
}

export function GetDefaultImagesResponseToJSON(value?: GetDefaultImagesResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetDefaultImagesResponseDataToJSON(value.data)
  }
}
